import { fetchBranches, createBranch as apiCreateBranch, updateBranch as apiUpdateBranch, deleteBranch as apiDeleteBranch } from '../../services/branchApi.js';

export const createAdminBranchesSlice = (set, get) => ({
  branches: [],
  selectedBranch: null,
  loading: false,
  error: null,
  dialogLoading: false,

  setBranches: (branches) => set((state) => ({
    admin: {
      ...state.admin,
      branches
    }
  })),
  setSelectedBranch: (branch) => set((state) => ({
    admin: {
      ...state.admin,
      selectedBranch: branch
    }
  })),
  setLoading: (loading) => set((state) => ({
    admin: {
      ...state.admin,
      loading
    }
  })),
  setError: (error) => set((state) => ({
    admin: {
      ...state.admin,
      error
    }
  })),
  setDialogLoading: (loading) => set((state) => ({
    admin: {
      ...state.admin,
      dialogLoading: loading
    }
  })),

  loadBranches: async () => {
    set((state) => ({
      admin: {
        ...state.admin,
        loading: true,
        error: null
      }
    }));
    try {
      const response = await fetchBranches();
      const branchList = response.branches || [];
      set((state) => ({
        admin: {
          ...state.admin,
          branches: branchList,
          selectedBranch: branchList[0] || null,
          loading: false
        }
      }));
    } catch (err) {
      set((state) => ({
        admin: {
          ...state.admin,
          error: err.message || 'Unable to load branches',
          loading: false
        }
      }));
    }
  },

  createBranch: async (branchData) => {
    set((state) => ({
      admin: {
        ...state.admin,
        dialogLoading: true
      }
    }));
    try {
      const response = await apiCreateBranch(branchData);
      const createdBranch = response.branch;
      set((state) => ({
        admin: {
          ...state.admin,
          branches: [...state.admin.branches, createdBranch],
          selectedBranch: createdBranch,
          dialogLoading: false
        }
      }));
      return createdBranch;
    } catch (err) {
      set((state) => ({
        admin: {
          ...state.admin,
          dialogLoading: false
        }
      }));
      throw err;
    }
  },

  updateBranch: async (id, branchData) => {
    set((state) => ({
      admin: {
        ...state.admin,
        dialogLoading: true
      }
    }));
    try {
      const response = await apiUpdateBranch(id, branchData);
      const updatedBranch = response.branch;
      set((state) => ({
        admin: {
          ...state.admin,
          branches: state.admin.branches.map((branch) =>
            branch.id === id ? updatedBranch : branch
          ),
          selectedBranch: updatedBranch,
          dialogLoading: false
        }
      }));
      return updatedBranch;
    } catch (err) {
      set((state) => ({
        admin: {
          ...state.admin,
          dialogLoading: false
        }
      }));
      throw err;
    }
  },

  deleteBranch: async (id) => {
    try {
      await apiDeleteBranch(id);
      set((state) => ({
        admin: {
          ...state.admin,
          branches: state.admin.branches.filter((branch) => branch.id !== id),
          selectedBranch: state.admin.selectedBranch?.id === id ? null : state.admin.selectedBranch
        }
      }));
    } catch (err) {
      throw err;
    }
  },

  toggleBranchStatus: async (branch) => {
    const newState = branch.state === 'Active' ? 'Inactive' : 'Active';
    return get().updateBranch(branch.id, { ...branch, state: newState });
  }
});